// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";

import AdminLayout from "layouts/Admin/Admin.js";
import RTLLayout from "layouts/RTL/RTL.js";
import ClientLayout from "layouts/Client/Client.js";

import "assets/scss/black-and-white.scss";
import "assets/demo/demo.css";
import "assets/css/nucleo-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import ThemeContextWrapper from "./components/ThemeWrapper/ThemeWrapper";
import BackgroundColorWrapper from "./components/BackgroundColorWrapper/BackgroundColorWrapper";
import { AuthProvider } from "views/AuthContext";
import { LanguageProvider } from "contexts/LanguageContext";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <LanguageProvider>
      <ThemeContextWrapper>
        <BackgroundColorWrapper>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Navigate to="/admin/login" replace />} />
                <Route path="/admin/*" element={<AdminLayout />} />
                <Route path="/rtl/*" element={<RTLLayout />} />
                <Route path="/*" element={<ClientLayout />} />
              </Routes>
            </BrowserRouter>
          </AuthProvider>
        </BackgroundColorWrapper>
      </ThemeContextWrapper>
    </LanguageProvider>
  </Provider>
);
